import { SimpleShowLayout, Show, TextField, ReferenceField, Labeled } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { employeeRequests } from "api/employeeApi";
import { tenants } from "utils/tenants";
import ApprovalSubstitutesSection from "./ApprovalSubstitutes/ApprovalSubstitutesSection";
import { SectionTitle } from "features/SectionTitle";

const ShowPositions = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за позиция"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Тип позиция">
              <ReferenceField
                source="typeId"
                reference={employeeRequests.getPositionTypesSelect()}
              >
                <TextField
                  label="Тип позиция"
                  source="name"
                />
              </ReferenceField>
            </Labeled>
          </Grid>
        </Grid>

        {settings.tenant === tenants.SU && <ApprovalSubstitutesSection />}
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowPositions;
